import { createFileRoute } from '@tanstack/react-router'
import { navigateGuard } from '@/utils/auth'
import { UserRole } from '@/constants/user'
import EvaluationDetail from '@/components/smartqc-detail-route/evaluation-detail/index.jsx'

export const Route = createFileRoute(
  '/_auth/smart-qc/manualQa/$smartQcId/calls/$qcTicketId',
)({
  beforeLoad: ({ location }) => {
    return navigateGuard(location, [UserRole.ADMINISTRATOR])
  },
  component: SmartQcCallDetailWrapper,
})

function SmartQcCallDetailWrapper() {
  const { smartQcId, qcTicketId } = Route.useParams()

  return <EvaluationDetail smartQcId={smartQcId} qcTicketId={qcTicketId} />
}
